import { SupplierDataRequestState } from './supplierInboxContracts';
import { SupplierRoutePath } from './routes';
// Display fields are getters (not plain strings) so every consumer — this
// array is plain data, not a component — reads a live-translated value
// through i18n.t() without needing its own useTranslation(), same pattern as
// Common/config/lockedFeatures.js. Object.freeze only locks the array itself
// (no push/pop/reassign); the getters on each item still evaluate live.
import i18n from 'i18n';

// Fixpack #15 (D-15): kept in the SAME order as LiteSidebar's FREE_ITEMS
// (the /supplier shell's own nav) — this was a stale duplicate missing the
// Drafts entry entirely; it now carries one, in the same "Review & Drafts
// before Emissions Data" order.
export const FREE_SUPPLIER_NAV_ITEMS = Object.freeze([
  {
    get label() {
      return i18n.t('freeSupplier:nav.gettingStarted', 'Getting Started');
    },
    url: SupplierRoutePath.Home,
    icon: 'faHome',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.myCompany', 'My Company');
    },
    url: SupplierRoutePath.Company,
    icon: 'faBuilding',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.installations', 'Installations');
    },
    url: SupplierRoutePath.Installations,
    icon: 'faIndustry',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.templateUpload', 'Template Upload');
    },
    url: SupplierRoutePath.Upload,
    icon: 'faFileImport',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.reviewAndDrafts', 'Review & Drafts');
    },
    url: SupplierRoutePath.Drafts,
    icon: 'faListCheck',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.emissionsData', 'Emissions Data');
    },
    url: SupplierRoutePath.EmissionFactors,
    icon: 'faFlask',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.shareAndPortal', 'Share & Portal');
    },
    url: SupplierRoutePath.Share,
    icon: 'faLink',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.dataRequests', 'Data Requests');
    },
    url: SupplierRoutePath.Inbox,
    icon: 'faEnvelopeOpenText',
    notification: 'requests',
  },
  {
    get label() {
      return i18n.t('freeSupplier:nav.embedWidget', 'Embed Widget');
    },
    url: SupplierRoutePath.Embed,
    icon: 'faCode',
  },
]);

export const getPendingSupplierRequests = (connections = []) =>
  connections.flatMap((connection) =>
    connection.requests
      .filter((request) => request.state === SupplierDataRequestState.Pending)
      .map((request) => ({ connection, request })),
  );

export const getSupplierInboxNotification = (connections = []) => {
  const pendingRequests = getPendingSupplierRequests(connections);
  if (pendingRequests.length === 0) return null;

  return {
    count: pendingRequests.length,
    title: i18n.t('freeSupplier:nav.pendingDataRequests', 'Pending data requests'),
    subtitle: i18n.t('freeSupplier:nav.requestsWaitingCount', {
      count: pendingRequests.length,
      defaultValue: '{{count}} request waiting',
      defaultValue_other: '{{count}} requests waiting',
    }),
    sections: [
      {
        title: i18n.t('freeSupplier:nav.dataRequests', 'Data Requests'),
        count: pendingRequests.length,
        color: 'bg-primaryColor',
        bgColor: 'bg-primaryColor/5',
        borderColor: 'border-primaryColor/20',
        items: pendingRequests.map(({ connection, request }) => ({
          name: connection.declarant.name,
          subtitle: `${request.reportingPeriod} · CN ${[
            ...new Set(request.lines.map((line) => line.cnCode)),
          ].join(', CN ')}`,
        })),
      },
    ],
  };
};
